/* import React from 'react'
import { NavLink } from 'react-router-dom'


export default function NavBar() {
  return (<>
    <div className='flex fixed  text-amber-500 top-0 z-30 bg-teal-700 backdrop-blur-sm bg-opacity-70 justify-center md:justify-between align-items text-xl overflow-x w-full  '>
      <div className='flex justify-center md:justify-between  items-start space-x-4 ms-4 p-2'>
      <img src="../../img/logoBlanc.png" alt="Logo" className=' hidden md:block md:w-3/6 pt-2  ' />
      <h1 className=' font-bold text-xl w-full  '><NavLink to="/">Leading Dance</NavLink></h1>
      </div>

      <div className='flex text-amber-500 font-bold  justify-end  space-x-8 pt-10 pr-8 hidden md:block '>
     
     <h4>07 08 09 10 11</h4>
     <h4>NEUVILLY</h4>

   </div>
 
       
    </div>
 
   </>
  )
}
 */

import React, { useState, useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // État pour gérer l'ouverture du menu mobile
  const menuRef = useRef(null); // Référence pour le menu mobile

  // Fonction pour basculer l'état du menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Fonction pour fermer le menu
  const closeMenu = () => {
    setIsOpen(false);
  };

  // useEffect pour gérer les clics en dehors du menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu(); // Ferme le menu si on clique en dehors
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    
    <div className="flex   text-white top-0 bg-black backdrop-blur-lg  justify-between   items-center text-xl overflow w-full py-2">
     
      <div className="flex justify-center md:justify-between items-center   z-10">
        
          <NavLink to="/" className="nom flex items-center p-4 space-x-2">
            <img src="../../img/logoBlanc.png" alt="Logo" className="ms-4 end p-0 w-1/5" />
            <h1 id='navTit' className='ms-0 ps-0  '>Leading Danse</h1>
          </NavLink>
       
      </div>

      {/* Menu Burger pour mobile */}
      <div className="lg:hidden flex items-center mr-8">
        <button onClick={toggleMenu} className="text-white focus:outline-none p-2">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
      </div>

      {/* Menu Desktop */}
      <div className="flex space-y-4 hidden lg:block space-x-4 justify-end py-4 mr-8 text-white">
        <NavLink to="/" className="underline-hover text-white" >Accueil</NavLink>
        <NavLink to="/a_propos" className="underline-hover text-white">À propos</NavLink>
        <NavLink to="/lady_style" className="underline-hover text-white">Lady Style</NavLink>
        <NavLink to="/prestations" className="underline-hover text-white">Prestations</NavLink>
        <NavLink to="/contact" className="underline-hover text-white">Contact</NavLink>
        <NavLink to="/informations" className="underline-hover text-white">Plus</NavLink>
      </div>

      {/* Menu Mobile (visible ou caché ) */}
      {isOpen && (
        <div ref={menuRef} className="lg:hidden fixed top-20 z-50 right-0 w-full justify-center bg-black  ">
          <div className="flex-col flex-wrap justify-center space-x-8 items-center space-y-4 text-center m-auto py-2 ">
          
            <ul>
            <li><NavLink to="/" className="underline-hover text-white" onClick={closeMenu}>Accueil</NavLink></li>
            <li><NavLink to="/a_propos" className="underline-hover text-white" onClick={closeMenu}>À propos</NavLink></li>
            <li><NavLink to="/prestations" className="underline-hover text-white" onClick={closeMenu}>Prestations</NavLink></li>
            <li><NavLink to="/lady_style" className="underline-hover text-white" onClick={closeMenu}>Lady Style</NavLink></li>
            <li><NavLink to="/contact" className="underline-hover text-white" onClick={closeMenu}>Contact</NavLink></li>
            <li><NavLink to="/informations" className="underline-hover text-white" onClick={closeMenu}>Plus</NavLink></li>
            </ul>
          </div>
        </div>
      )}
    </div>
    
  );
};

export default Navbar;
